// Copyright (c) 2017 Deere & Company

import RegistrationForm from '../../product/product-registration/components';

export default {
    component: RegistrationForm,
    name: 'NEW_REGISTER_EDIT',
    path: 'new-registrations/:registrationId'
};



// WEBPACK FOOTER //
// ./src/routes/products/new-registration-form-edit.js